import React from 'react';
import './Contact.css';
import { ContactForms } from './ContactForms';

export const Contact = () => {
  return (
    <section className='contact-section' id='contact'>
      <ContactForms />
    </section>
  );
};
